import { createServerFn } from "@tanstack/react-start";

/**
 * Returns the publishable Razorpay Key ID for client-side widgets
 * (Affordability Widget, etc.). Never returns the secret.
 */
export const getRazorpayPublicKey = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ keyId: string | null }> => {
    const keyId = process.env.RAZORPAY_KEY_ID ?? null;
    return { keyId };
  },
);
